import { Pipe, PipeTransform } from '@angular/core';

// Replace \r\n on <br>-tags
@Pipe({
	name: 'commonLineToBr',
})
export class CommonLineToBrPipe implements PipeTransform {
	transform(data) {
		return data ? data.replace(/(?:\r\n|\r|\n)/g, '<br />') : data;
	}
}
